import { takeLatest, call, put, all } from "redux-saga/effects"
import { arrayToTree } from "performant-array-to-tree"
import axios from "axios"
import { push } from "connected-react-router"
import { filter, map, get, isEmpty } from "lodash"
import {
  DOWNLOAD_SURVEY_WATCHER,
  GET_SURVEY_WATCHER,
  UPDATE_DIMENSION_WATCHER,
  UPDATE_QUESTION_WATCHER,
  GET_DIMENSIONS_QUESTION_WATCHER,
  CREATE_QUESTION_WATCHER,
  GET_QUESTION_TYPES_WATCHER,
  GET_QUESTION_WATCHER,
  GET_DIMENSION_WATCHER,
  GET_SURVEY_QUALITATIVE_WATCHER,
  UPDATE_SURVEY_WATCHER,
  DELETE_SURVEY_WATCHER,
  UPDATE_QUESTIONDIMENSION_WATCHER,
  DELETE_QUESTION_WATCHER,
  UPDATE_QUALITATIVE_WATCHER,
  GET_CONFIG_SURVEY_WATCHER,
  UPDATE_CONFIG_SURVEY_WATCHER,
  GET_QUESTIONS_WATCHER,
  SEND_EMAIL_PREVIEW_SURVERY_WATCHER,
  UPLOAD_BG_IMAGE_WATCHER,
  UPLOAD_LOGO_WATCHER,
  DELETE_ALL_QUESTIONS_WATCHER,
  GET_QUESTION_MULTIPLE_CHOICE_WATCHER,
  GET_SEGMENTS_WATCHER,
  GET_SURVEY_TYPES_WATCHER,
  GET_SCOPE_TYPES_WATCHER,
} from "./constants"
import {
  uploadBgImageWatcher,
  getSurveyWatcher,
  getSurveySuccess,
  getSurveyFailed,
  deleteSurveyFailed,
  updateDimensionFailed,
  getDimensionsQuestionSuccess,
  getDimensionsQuestionFailed,
  createQuestionFailed,
  updateQuestionSuccess,
  updateQuestionFailed,
  getQuestionTypesSuccess,
  getQuestionTypesFailed,
  getQuestionSuccess,
  getQuestionFailed,
  getSurveyEnpsWatcher,
  getSurveyEnpsSuccess,
  getDimensionSuccess,
  getDimensionFailed,
  getSurveyQualitativeWatcher,
  getSurveyQualitativeSuccess,
  getSurveyQualitativeFailed,
  updateSurveyFailed,
  deleteQuestionSuccess,
  deleteQuestionFailed,
  getConfigSurveySuccess,
  updateConfigSurveyFailed,
  getQuestionsSuccess,
  sendEmailPreviewSurveyFailed,
  uploadBgImageSuccess,
  uploadBgImageFailed,
  uploadLogoSuccess,
  uploadLogoFailed,
  getQuestionsWatcher,
  deleteAllQuestionsFailed,
  deleteAllQuestionsSuccess,
  createQuestionSuccess,
  getQuestionsMultipleChoiceSuccess,
  getQuestionsMultipleChoiceFailed,
  getQuestionsMultipleChoiceWatcher,
  getSegmentsSuccess,
  getSegmentsFailed,
  getSurveyTypesFailed,
  getSurveyTypesSuccess,
  getScopeTypesFailed,
  getScopeTypesSuccess,
} from "./actions"
import {
  operationSurveySegment,
  editQuestionSegment,
  editSettingSegment,
} from "../../utils/segment/Survey/surveyTrack"
import {
  isModuleBySlug,
  LOCAL_COMPANY_ID,
  LOCAL_TOKEN,
} from "../../utils/storage"
import {
  getQuestionsMultipleChoiceApi,
  getSurveyTypesCreateApi,
} from "../../utils/routes/routes-survey"
import { NPS_LEADER } from "../../utils/constants"

function messageProgress(messagex) {
  message.loading(messagex, 0)
}

function messageSuccess(messagex) {
  message.success(messagex, 5)
}

function messageFailed(messagex) {
  message.error(messagex, 5)
}

function messageDestroy() {
  message.destroy()
}

export function getSegmentsApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}segments/list`,
  })
}

export function getSurveyTypesApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}surveytypes`,
  })
}

export function getScopeTypesApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}scope-types`,
  })
}

export function* getSegmentsSaga() {
  try {
    const { data, status } = yield call(getSegmentsApi)
    if (status === 200) {
      yield put(getSegmentsSuccess(data.data))
    }
  } catch (error) {
    yield put(getSegmentsFailed())
    returnMessage(error)
  }
}

export function* getSurveyTypesSaga() {
  try {
    const { data, status } = yield call(getSurveyTypesCreateApi)
    if (status === 200) {
      yield put(getSurveyTypesSuccess(data))
    }
  } catch (error) {
    yield put(getSurveyTypesFailed())
    returnMessage(error)
  }
}

export function* getScopeTypesSaga() {
  try {
    const { data, status } = yield call(getScopeTypesApi)
    if (status === 200) {
      yield put(getScopeTypesSuccess(data.data))
    }
  } catch (error) {
    yield put(getScopeTypesFailed())
    returnMessage(error)
  }
}

// GET SURVEY QUALITATIVE
export function getSurveyQualitativeApi(idSurvey) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}surveys/${idSurvey}/questions/qualitative`,
  })
}
export function* getSurveyQualitativeSaga(action) {
  try {
    const { data, status } = yield call(getSurveyQualitativeApi, action.payload)

    if (status === 200) {
      yield put(getSurveyQualitativeSuccess(data))
    }
  } catch (error) {
    yield put(getSurveyQualitativeFailed())
  }
}

// GET SURVEY ENPS
export function getSurveyEnpsWatcherApi(idSurvey) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}surveys/${idSurvey}/questions/enps`,
  })
}

// export function* getSurveyEnpsWatcherSaga(action) {
//   try {
//     const { status, data } = yield call(getSurveyEnpsWatcherApi, action.payload);

//     if (status === 200) {
//       yield put(getSurveyEnpsSuccess(data))
//     }
//   } catch (error) {
//     yield put(getSurveyEnpsFailed())
//   }
// }

// GET SURVEY
export function getSurveyWatcherApi(idSurvey) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}surveys/${idSurvey}/summary`,
  })
}

export function* getSurveyWatcherSaga(action) {
  try {
    const [{ status, data }] = yield all([
      call(getSurveyWatcherApi, action.payload),
    ])

    const isNpsLeader = isModuleBySlug(NPS_LEADER)
    let dataEnps = {}
    let engagementContent = {}
    const [questionEnps] = yield all([
      call(getSurveyEnpsWatcherApi, action.payload),
    ])
    dataEnps = questionEnps.data
    engagementContent = get(data, "data.engagement[0]", {})
    const enpsTrueEngagement = get(questionEnps, "data.data[0]", {})
    if (enpsTrueEngagement.engagement) {
      dataEnps = {}
      engagementContent = {
        ...engagementContent,
        subdimensions: [
          ...engagementContent.subdimensions,
          {
            dimension_name: get(questionEnps, "data.meta.title", ""),
            dimension_title: get(questionEnps, "data.meta.title", ""),
            dimension_enabled: enpsTrueEngagement.enabled,
            dimension_id_dimension_has_survey:enpsTrueEngagement.id_question_has_dimension,
            question_id_question_has_dimensions:enpsTrueEngagement.id_question_has_dimension,
            subdimensions: [],
            questions: [
              {
                question_enabled: enpsTrueEngagement.enabled,
                question_generic: enpsTrueEngagement.generic,
                question_id_question: enpsTrueEngagement.id_question,
                question_id_question_has_dimensions:
                  enpsTrueEngagement.id_question_has_dimension,
                question_id_question_type: enpsTrueEngagement.id_question_type,
                question_name: enpsTrueEngagement.name,
                question_segments: enpsTrueEngagement.question_segments,
                required: enpsTrueEngagement.required
              },
            ],
          },
        ],
      }
    }

    const dataForNextLine = isEmpty(engagementContent)
      ? data.data.summary
      : [engagementContent, ...data.data.summary]
    const subdimensionsParsed = map(dataForNextLine, (dimension) => ({
      ...dimension,
      subdimensions: filter(
        dimension.subdimensions,
        (item) => item.questions.length
      ),
    }))

    const dimensionParsed = filter(
      subdimensionsParsed,
      (item) => item.questions.length || item.subdimensions.length
    )

    const dataParsed = {
      summary: dimensionParsed,
      engagement: data.data.engagement,
      hasLikertQuestions: data.data.has_likert_questions,
      survey: {
        ...data.data.survey,
        is_deletable: data.data.is_deletable,

        measures: data.data.measures,
        measures_in_use_count: data.data.measures_in_use_count,
      },
    }

    if (status === 200) {
      yield put(getSurveyEnpsSuccess(dataEnps))
      yield put(getSurveySuccess(dataParsed))
    }
  } catch (error) {
    yield put(getSurveyFailed())
  }
}

// UPDATE SURVEY
export function updateSurveyApi({ idSurvey, params = {} }) {
  return axios.request({
    method: "PUT",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}surveys/${idSurvey}`,
    data: params,
  })
}

export function* updateSurveySaga(action) {
  try {
    const { status, data } = yield call(updateSurveyApi, action.payload)

    if (status === 200) {
      const params = data.data.survey.id_survey
      yield put(getSurveyWatcher(params))
      yield call(messageSuccess, data.data.msj)
    }
  } catch (error) {
    yield put(updateSurveyFailed())
    returnMessage(error)
  }
}

// DELETE SURVEY
export function deleteSurveyApi(idSurvey) {
  return axios.request({
    method: "delete",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}surveys/${idSurvey}`,
  })
}

export function* deleteSurveySaga(action) {
  try {
    const { status, data } = yield call(deleteSurveyApi, action.payload)

    if (status === 200) {
      yield call(messageSuccess, data.data.msj)
      yield put(push("/models/surveys"))
    }
  } catch (error) {
    yield put(deleteSurveyFailed())
  }
}

// DELETE ALL QUESTIONS
export function deleteAllQuestionsApi(idSurvey) {
  return axios.request({
    method: "delete",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}surveys/${idSurvey}/questions`,
  })
}

export function* deleteAllQuestionsSaga(action) {
  try {
    const { status, data } = yield call(deleteAllQuestionsApi, action.payload)
    if (status === 200) {
      yield call(messageSuccess, data.data.msj)
      yield put(deleteAllQuestionsSuccess())
    }
  } catch (error) {
    yield put(deleteAllQuestionsFailed())
  }
}

// GET DIMENSIONS QUESTION
export function getDimensionsQuestionApi(idSurvey) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}surveys/${idSurvey}/dimensions`,
  })
}

export function* getDimensionsQuestionSaga(action) {
  try {
    const { status, data } = yield call(
      getDimensionsQuestionApi,
      action.payload
    )
    const dataTree = arrayToTree(data.data, {
      id: "id_dimension",
      parentId: "id_dimension_parent",
    })

    if (status === 200) {
      yield put(getDimensionsQuestionSuccess(dataTree))
    }
  } catch (error) {
    yield put(getDimensionsQuestionFailed())
  }
}

// GET QUESTION
export function getQuestionApi(idQuestion) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}questions/${idQuestion}?relation=dimensionhassurveys`,
  })
}

export function* getQuestionSaga(action) {
  try {
    const { data, status } = yield call(getQuestionApi, action.payload)

    if (status === 200) {
      yield put(getQuestionSuccess(data.data))
    }
  } catch (error) {
    yield put(getQuestionFailed())
  }
}

// CREATE QUESTION
export function createQuestionApi(params) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}questions`,
    data: params,
  })
}

export function* createQuestionSaga(action) {
  try {
    const { data, status } = yield call(createQuestionApi, action.payload)

    if (status === 201) {
      yield call(messageSuccess, data.data.msj)
      const params = data.data.question.id_survey
      yield put(getSurveyWatcher(params))
      yield put(getSurveyEnpsWatcher(params))
      yield put(getSurveyQualitativeWatcher(params))
      yield put(getQuestionsWatcher(params))
      yield put(getQuestionsMultipleChoiceWatcher(params))
    }
    yield put(createQuestionSuccess())
  } catch (error) {
    yield put(createQuestionFailed())
  }
}

// UPDATE QUESTION
export function updateQuestionApi({ idQuestion, params }) {
  return axios.request({
    method: "put",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}questions/${idQuestion}`,
    data: params,
  })
}

export function* updateQuestionSaga(action) {
  try {
    const { data, status } = yield call(updateQuestionApi, action.payload)
    const survey = yield call(
      getSurveyWatcherApi,
      action.payload.params.id_survey
    )
    if (status === 200) {
      yield put(updateQuestionSuccess(data))
      const params = data.data.question.id_survey
      yield put(getSurveyWatcher(params))
      yield put(getSurveyEnpsWatcher(params))
      yield put(getSurveyQualitativeWatcher(params))
      yield put(getQuestionsMultipleChoiceWatcher(params))
      editQuestionSegment(
        action.payload.params.infoEditSegment,
        survey.data.data.survey
      )
    }
  } catch (error) {
    yield put(updateQuestionFailed())
  }
}

// DELETE QUESTION
export function deleteQuestionApi({ idQuestion }) {
  return axios.request({
    method: "delete",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}questions/${idQuestion}`,
  })
}

export function* deleteQuestionSaga(action) {
  try {
    const { data, status } = yield call(deleteQuestionApi, action.payload)

    if (status === 200) {
      yield put(deleteQuestionSuccess(data))
      const params = action.payload.idSurvey
      yield put(getSurveyWatcher(params))
      yield put(getSurveyEnpsWatcher(params))
      yield put(getSurveyQualitativeWatcher(params))
      yield put(getQuestionsMultipleChoiceWatcher(params))
      yield call(messageSuccess, data.data.msj)
    }
  } catch (error) {
    yield put(deleteQuestionFailed())
  }
}

// GET QUESTION TYPES
export function getQuestionTypesApi(idSurvey) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}surveys/${idSurvey}/questiontypes`,
  })
}

export function* getQuestionTypesSaga(action) {
  try {
    const { status, data } = yield call(getQuestionTypesApi, action.payload)

    if (status === 200) {
      yield put(getQuestionTypesSuccess(data.data))
    }
  } catch (error) {
    yield put(getQuestionTypesFailed())
  }
}

// GET DIMENSION
export function getDimensionApi(idDimension) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}dimensionshassurvey/${idDimension}`,
  })
}

export function* getDimensionSaga(action) {
  try {
    const { data, status } = yield call(getDimensionApi, action.payload)

    if (status === 200) {
      yield put(getDimensionSuccess(data.data))
    }
  } catch (error) {
    yield put(getDimensionFailed())
  }
}

// UPDATE DIMENSION
export function updateDimensionApi({ idDimension, params }) {
  return axios.request({
    method: "put",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}dimensionshassurvey/${idDimension}`,
    data: params,
  })
}

export function* updateDimensionSaga(action) {
  try {
    const { data, status } = yield call(updateDimensionApi, action.payload)

    if (status === 200) {
      // yield put(updateDimensionSuccess(data))
      const params = data.data.dimensionhassurvey.id_survey

      yield put(getSurveyWatcher(params))
      // yield put(getSurveyEnpsWatcher(params));
    }
  } catch (error) {
    yield put(updateDimensionFailed())
  }
}

// UPDATE_QUESTIONDIMENSION_WATCHER
export function updateQuestionDimensionApi({ idQuestion, params = {} }) {
  return axios.request({
    method: "put",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}questionhasdimensions/${idQuestion}`,
    data: params,
  })
}

export function* updateQuestionDimensionSaga(action) {
  try {
    const { data, status } = yield call(
      updateQuestionDimensionApi,
      action.payload
    )

    if (status === 200) {
      const params = data.data.question.id_survey
      yield put(getSurveyWatcher(params))
      yield put(getSurveyEnpsWatcher(params))
      yield put(getSurveyQualitativeWatcher(params))
      yield put(getQuestionsMultipleChoiceWatcher(params))
    }
  } catch (error) {}
}

// UPDATE QUESTION QUALITATIVE
export function updateQualitativeApi({ idSurvey, params = {} }) {
  return axios.request({
    method: "put",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}surveys/${idSurvey}/questions/qualitative`,
    data: params,
  })
}

export function* updateQualitativeSaga(action) {
  try {
    const { status } = yield call(updateQualitativeApi, action.payload)

    if (status === 200) {
      const params = action.payload.idSurvey

      yield put(getSurveyQualitativeWatcher(params))
    }
  } catch (error) {}
}

// GET SURVEY CONFIG
export function getConfigSurveyApi(idSurvey) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}surveys/${idSurvey}/configuration`,
    // TODO team manage status response back
    validateStatus: (status) => true, // I'm always returning true,
    // you may want to do it depending on the status received
  })
}

export function* getConfigSurveySaga(action) {
  // TODO team manage status response back
  try {
    const result = yield call(getConfigSurveyApi, action.payload)
    const { data } = result.data
    switch (result.status) {
      case 200:
        yield put(getConfigSurveySuccess(data))
        break
      default:
        yield call(messageFailed, data.error)
        yield put(push("/error"))
        break
    }
  } catch (e) {
    yield call(messageFailed, "Error en el servidor")
    yield put(push("/login"))
  }
}

// UPDATE SURVEY CONFIG
export function updateConfigSurveyApi({ idSurvey, params }) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}surveys/${idSurvey}/configuration`,
    data: params,
  })
}

export function* updateConfigSurveySaga(action) {
  try {
    const { data } = yield call(updateConfigSurveyApi, action.payload)
    yield call(messageSuccess, data.data.msj)
    yield put(getConfigSurveySuccess(data.data.survey))
    editSettingSegment(action.payload.editSettingSegment, data.data.survey)
    // yield put(uploadBgImageWatcher({idSurvey: action.payload.idSurvey}))
  } catch (error) {
    yield put(updateConfigSurveyFailed())
  }
}

// DOWNLOAD EXCEL SURVEY
function getSurveyExcelApi(idSurvey) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/survey/${idSurvey}/export/xlsx/download`,
  })
}

function getSurveyExcelProgress() {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/survey/export/xlsx/progress`,
  })
}

function downloadSurveyUrl(url) {
  location.replace(url)
}

export function* downloadSurveySaga(action) {
  const survey = yield call(getSurveyWatcherApi, action.payload)
  try {
    yield call(messageProgress, "Descargando archivo")
    yield call(getSurveyExcelApi, action.payload)
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))
      data = yield call(getSurveyExcelProgress)

      if (data.status === 200) {
        break
      }
    }

    yield call(messageDestroy)
    yield call(
      messageSuccess,
      getStatusSurveyExport("Archivo descargado", survey)
    )
    yield call(downloadSurveyUrl, data.data[0].url)
  } catch (e) {
    yield call(messageDestroy)
    yield call(
      messageFailed,
      getStatusSurveyExport("Error al descargar archivo", survey)
    )
  }
}

function getStatusSurveyExport(status, survey) {
  operationSurveySegment(status, survey.data.data.survey, "exportSurvey", "")
  return status
}

// GET QUESTIONS
export function getQuestionsApi(idSurvey) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}questionnaire/${idSurvey}`,
  })
}

export function* getQuestionsSaga(action) {
  try {
    const { status, data } = yield call(getQuestionsApi, action.payload)

    if (status === 200) {
      yield put(getQuestionsSuccess(data.data))
    }
  } catch (error) {}
}

// SEND EMAIL PREVIEW
export function SendEmailPreviewSurveyApi({ idSurvey, params = {} }) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}surveys/${idSurvey}/send/demo`,
    data: { ...params },
  })
}
export function* SendEmailPreviewSurveySaga(action) {
  try {
    const { status, data } = yield call(
      SendEmailPreviewSurveyApi,
      action.payload
    )
    if (status === 200) {
      yield call(messageSuccess, data.message)
    }
  } catch (error) {
    yield put(sendEmailPreviewSurveyFailed())
  }
}

// UPLOAD BG IMAGE
export function uploadBgImageApi({ idSurvey, data = {} }) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}survey/${idSurvey}/upload/background`,
    data,
  })
}

export function* uploadBgImageSaga(action) {
  try {
    const { status, data } = yield call(uploadBgImageApi, action.payload)

    if (status === 200) {
      yield put(uploadBgImageSuccess(data))
    }
  } catch (error) {
    yield put(uploadBgImageFailed({}))
    const {
      response: {
        data: {
          errors: { uploaded_file },
        },
      },
    } = error

    messageFailed(uploaded_file[0])
  }
}

// UPLOAD LOGO
export function uploadLogoApi({ idSurvey, data = {} }) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}survey/${idSurvey}/upload/logo`,
    data,
  })
}
export function* uploadLogoSaga(action) {
  try {
    const { status, data } = yield call(uploadLogoApi, action.payload)

    if (status === 200) {
      yield put(uploadLogoSuccess(data.pathImage))
    }
  } catch (error) {
    yield put(uploadLogoFailed(""))

    const {
      response: {
        data: {
          errors: { uploaded_file },
        },
      },
    } = error

    messageFailed(uploaded_file[0])
  }
}

export function* getQuestionsMultipleChoiceSaga(action) {
  try {
    const listQuestionMultipleChoice = yield call(
      getQuestionsMultipleChoiceApi,
      action.payload
    )
    yield put(getQuestionsMultipleChoiceSuccess(listQuestionMultipleChoice))
  } catch (e) {
    yield put(getQuestionsMultipleChoiceFailed())
  }
}

// Individual exports for testing
export default function* surveySaga() {
  yield takeLatest(UPDATE_CONFIG_SURVEY_WATCHER, updateConfigSurveySaga)
  yield takeLatest(GET_CONFIG_SURVEY_WATCHER, getConfigSurveySaga)
  yield takeLatest(UPDATE_QUALITATIVE_WATCHER, updateQualitativeSaga)
  yield takeLatest(DELETE_QUESTION_WATCHER, deleteQuestionSaga)
  yield takeLatest(
    UPDATE_QUESTIONDIMENSION_WATCHER,
    updateQuestionDimensionSaga
  )
  yield takeLatest(GET_SURVEY_WATCHER, getSurveyWatcherSaga)
  yield takeLatest(UPDATE_SURVEY_WATCHER, updateSurveySaga)
  yield takeLatest(DELETE_SURVEY_WATCHER, deleteSurveySaga)
  yield takeLatest(DELETE_ALL_QUESTIONS_WATCHER, deleteAllQuestionsSaga)
  // yield takeLatest(GET_SURVEY_ENPS_WATCHER, getSurveyEnpsWatcherSaga);
  yield takeLatest(GET_SURVEY_QUALITATIVE_WATCHER, getSurveyQualitativeSaga)
  yield takeLatest(UPDATE_DIMENSION_WATCHER, updateDimensionSaga)
  yield takeLatest(UPDATE_QUESTION_WATCHER, updateQuestionSaga)
  yield takeLatest(GET_DIMENSIONS_QUESTION_WATCHER, getDimensionsQuestionSaga)
  yield takeLatest(CREATE_QUESTION_WATCHER, createQuestionSaga)
  yield takeLatest(GET_QUESTION_TYPES_WATCHER, getQuestionTypesSaga)
  yield takeLatest(GET_QUESTION_WATCHER, getQuestionSaga)
  yield takeLatest(GET_DIMENSION_WATCHER, getDimensionSaga)
  yield takeLatest(DOWNLOAD_SURVEY_WATCHER, downloadSurveySaga)
  yield takeLatest(GET_QUESTIONS_WATCHER, getQuestionsSaga)
  yield takeLatest(
    SEND_EMAIL_PREVIEW_SURVERY_WATCHER,
    SendEmailPreviewSurveySaga
  )
  yield takeLatest(UPLOAD_BG_IMAGE_WATCHER, uploadBgImageSaga)
  yield takeLatest(UPLOAD_LOGO_WATCHER, uploadLogoSaga)
  yield takeLatest(
    GET_QUESTION_MULTIPLE_CHOICE_WATCHER,
    getQuestionsMultipleChoiceSaga
  )
  yield takeLatest(GET_SEGMENTS_WATCHER, getSegmentsSaga)
  yield takeLatest(GET_SURVEY_TYPES_WATCHER, getSurveyTypesSaga)
  yield takeLatest(GET_SCOPE_TYPES_WATCHER, getScopeTypesSaga)
}
